export default __webpack_public_path__ + "static/media/showit-logo.5a254880.png";